import { SongInput } from "../../php/input/SongInput";
import { SongRequest } from "../../php/request/SongRequest";
import { Rokojori } from "../../Rokojori";
import { PlayingSongInfo } from "../data/PlayingSongInfo";
import { RadioChannelType } from "../data/RadioChannel";
import { AudioPlayer } from "../../../../library-js/audio/AudioPlayer";
import { AudioGraph } from "../../../../library-js/audio/graph/AudioGraph";
import { Radio } from "../Radio";
import { SongInfo } from "../data/SongInfo";
import { PlayedSongInfo } from "../../php/request/RadioNextSong";

export class RadioPlayer
{
  channel:RadioChannelType;
  _audioPlayer:AudioPlayer;
  _graph:AudioGraph;
  _mainVolume:number = 100/125;
  //_currentSongInfo:PlayingSongInfo;
  _currentSong:SongInfo;
  _history:SongInfo[] = [];  
  _waitingForNext = false;
  _pauseUntilNextMS = 100; 


  initialize()
  {
    this._graph = new AudioGraph();
    this._audioPlayer = new AudioPlayer( this._graph );
  }

  get isPlaying()
  {
    if ( ! this._audioPlayer )
    {
      return false;
    }

    if ( ! this._audioPlayer._audioElement )
    {
      return false;
    }

    return ! this._audioPlayer._audioElement.paused;
  }

  update()
  {
    if ( ! this._audioPlayer )
    {
      return;
    }

    this._audioPlayer.volume = this._mainVolume;

    if ( ! this._waitingForNext && this.playedSeconds > 5 && this.playedSeconds > ( this.songLength - 3 ) )
    { 
      console.log( "SCHEDULE THROUGH UPDATE", this.playedSeconds, this.songLength );
      this._waitingForNext = true;
      setTimeout(
        ()=>
        {
          this.scheduleNext();
        },
        3000
      )
      
    } 
  }

  scheduleNext()
  {    
    this._waitingForNext = true;
    
    setTimeout(
      async ()=>
      {
        let randomSong = await Radio.getNextSongInfo( this.channel );
        window.location.hash = randomSong.songHash;
      },
      this._pauseUntilNextMS
    );
    
  }


  stop()
  {
    this._audioPlayer.pause();
  }

  get currentSongInfo()
  {
    return this._currentSong;
  }

  /*async play( info:PlayingSongInfo )
  {
    console.log( "PLAYING", info );
    this._waitingForNext = false;
    this._currentSongInfo = info;
    let request   = new SongRequest();
    let inputData = new SongInput();

    inputData.id = info.id;
    inputData.channel = this.channel;

    let url = request.asURL( Rokojori.phpContext, inputData );

    this._audioPlayer.setSource( url );
    this._audioPlayer.play();
  }*/

  get playedHistory():PlayedSongInfo[]
  {
    return this._history.map( i => PlayedSongInfo.create( i.channel, i.songID ) );
  }

  async playSong( info:SongInfo )
  {
    console.log( "PLAYING", info );
    this._waitingForNext = false;
    this._currentSong = info;
    let request   = new SongRequest();
    let inputData = new SongInput();

    inputData.id = info.songID;
    inputData.channel = this.channel;

    let url = request.asURL( Rokojori.phpContext, inputData );
    
    this._history.push( info );
    
    if ( this._history.length > 100 )
    {
      this._history.shift();
    }

    this._audioPlayer.setSource( url );
    this._audioPlayer.play();
  }

  get mainVolume()
  {
    return this._mainVolume;
  }

  set mainVolume( value:number )
  {
    this._mainVolume = value;
  }

  get audioElement()
  {
    return this._audioPlayer._audioElement;
  }

  get songLength()
  {
    return ! this._currentSong ? 0 : this._currentSong.duration;
  }

  get playState()
  {
    return this.playedSeconds / this.songLength;
  }

  get playedSeconds()
  {
    return this._audioPlayer.playedSeconds;
  }

  get secondsLeft()
  {
    return this.songLength - this.playedSeconds;
  }
}